import { dateToYYYYMMDD, parseDateYYYYMMDD } from '@mummssoftware/utils/dates';
import { formatPhysicianName } from '@mummssoftware/utils/formatters';
import { Nil } from '@mummssoftware/utils/utils';
import { property } from 'lodash';

type Triple<T> = [T, T, T];

const prepend = (a: string) => (b: string) => `${a}${b}`;

export const apply = (a: any) => (func: any) => func(a);

const nameFields = ['firstname', 'lastname', 'credentials'];

const formatBackendName = (prefix: 'person' | 'patient') => (
  dto: mumms.Incident | any,
) => {
  const fieldGetters = nameFields.map(prepend(prefix)).map(property) as Triple<
    (a: any) => string | null
  >;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return formatPhysicianName(null, ...fieldGetters.map(apply(dto)));
};

export const formatPersonName = formatBackendName('person');

export const formatPatientName = formatBackendName('patient');

const ifThen = (a: any) => (b: any) => (a ? b : '');

const personIsUser = (
  dto: mumms.patient | mumms.User | Nil,
): dto is mumms.User => !!dto && 'userCredentials' in dto;

export const toNameFields = (prefix: 'person' | 'patient') => (
  dto: (mumms.patient | mumms.User) | Nil,
) => ({
  [`${prefix}firstname`]: ifThen(dto)(dto?.firstName),
  [`${prefix}lastname`]: ifThen(dto)(dto?.lastName),
  ...(personIsUser(dto) && { personcredentials: dto.userCredentials }),
});

const parseVisitDate = (appVisit: mumms.Visit) =>
  parseDateYYYYMMDD(appVisit.effectivedate);

export const getBlankIncident = (
  currentUser: mumms.User | Nil,
  patient: mumms.patient,
  siteid: string,
  appVisit: mumms.Visit | Nil,
) => ({
  siteid,
  personid: String(currentUser?.userId),
  patientid: patient && String(patient?.id),
  ...toNameFields('person')(currentUser),
  ...toNameFields('patient')(patient),
  details: '',
  incidentdatetime_utc: dateToYYYYMMDD(
    appVisit ? parseVisitDate(appVisit) : new Date(),
  ),
  incidenttype: '',
});
